export default [
  {
    for: 'frontend-user',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
      unlockEntity: true,
      blockEntity: true,
    },
  },
];
